// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1T4y9","location":"Header_location__1x5Cf"};